/** @jsxRuntime classic */
/** @jsx jsx */
import {css, jsx} from "@emotion/core";
import React, {CSSProperties} from 'react';
import {Container} from "@ice/components";


interface FormContainerProps {
    style?: CSSProperties;
}


interface FormContainerState {
}


export class FormContainer extends React.Component<FormContainerProps, FormContainerState> {

    constructor(props: FormContainerProps) {
        super(props);
        this.state = {
        }
    };

    render = () => {
        return (
            <Container
                overflow="y"
                style={this.props.style}
                css={(theme) => css`
					& > .ice-form-group {
						margin-bottom: 0;
						& > label {
							width: 6em;
						}
						& > div {
							padding: 3px;
						}
						.ice-select-control {
							background-color: ${theme.backgroundColor.default};
						}
					}
				`}
            >
                {this.props.children}
            </Container>
        );
    }

}
